import ContentParameterRegister from 'features/content-parameter-register/ContentParameterRegister';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';
import SiteConfigPage from 'pages/site-config/shared/SiteConfigPage';

function SiteConfigContentPresentationNew() {
  useRequireRoles(ROLE_TYPE.ADMIN, ROLE_TYPE.SUPER);

  return (
    <SiteConfigPage title="Register Section Page">
      <ContentParameterRegister />
    </SiteConfigPage>
  );
}

export default SiteConfigContentPresentationNew;
